var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: "cart-recap" } },
    [
      _vm.showEligibilityResult && _vm.cartRecapData.eligibilityResult
        ? _c("EligibilityResult", {
            attrs: {
              "eligibility-result": _vm.cartRecapData.eligibilityResult,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row px-1" }, [
          _c("div", { staticClass: "col-12 px-0" }, [
            _c("h3", {
              staticClass: "mb-md-2 mb-1",
              domProps: { innerHTML: _vm._s(_vm.cartRecapData.titleHtml) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 px-1 px-lg-0 mb-2 mb-md-3" }, [
            _c("div", { staticClass: "row px-0" }, [
              _c("div", { staticClass: "col-12 col-lg-8 px-0 px-lg-1" }, [
                _c("div", { staticClass: "row h-100 px-0" }, [
                  _c(
                    "section",
                    {
                      staticClass: "order-1 col-12 col-lg-6 px-1 pb-1 pb-lg-0",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container mw-100 h-100 border-gray recap-mobile-tile px-0",
                        },
                        [
                          _c("div", { staticClass: "row p-1" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.mobileOffer.name)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 text-end" },
                              [
                                _c("ob1-prix", {
                                  attrs: {
                                    custom: "recap-ob1-price h3 text-dark",
                                    duration: _vm.mobileOffer.price.duration,
                                    "initial-price":
                                      _vm.mobileOffer.price.initialPrice,
                                    "is-mini": true,
                                    price: _vm.mobileOffer.price.price,
                                    "price-details":
                                      _vm.mobileOffer.price.priceDetails,
                                    "show-by-month":
                                      _vm.mobileOffer.price.showByMonth,
                                    "show-end-of-promotion-price":
                                      _vm.mobileOffer.price
                                        .showEndOfPromotionPrice,
                                    "show-from": _vm.mobileOffer.price.showFrom,
                                    "show-promo-duration":
                                      _vm.mobileOffer.price.showPromoDuration,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.offerHasVariation
                            ? _c("div", { staticClass: "row p-1" }, [
                                _c("div", { staticClass: "col-6" }, [
                                  _c("p", [
                                    _c("strong", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.blockedMobileOfferTitle
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "ob1-switch col-6" }, [
                                  _c("input", {
                                    staticClass: "checkbox visually-hidden",
                                    attrs: {
                                      id: "mobileOfferBlocked",
                                      name: "isMobileOfferBlocked",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      checked: _vm.mobileOffer.blocked,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onMobileOfferToggleChange(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "toggle toggle-rounded labels",
                                      staticStyle: { float: "right" },
                                      attrs: {
                                        for: "mobileOfferBlocked",
                                        "data-oevent-category":
                                          _vm.blockedMobileOfferToggleTms
                                            .category,
                                        "data-oevent-label": _vm.mobileOffer
                                          .blocked
                                          ? "non"
                                          : "oui",
                                        "data-oevent-action":
                                          _vm.blockedMobileOfferToggleTms
                                            .action,
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "on" }, [
                                        _vm._v("Oui"),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "off" }, [
                                        _vm._v("Non"),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c("a", {
                                    staticClass: "ob1-link-arrow pt-0",
                                    attrs: {
                                      href: "#",
                                      "data-bs-toggle": "modal",
                                      "data-bs-target":
                                        "#modal-more-information",
                                      "data-oevent-category":
                                        _vm.blockedMobileOfferPopinTms.category,
                                      "data-oevent-label":
                                        _vm.blockedMobileOfferPopinTms.label,
                                      "data-oevent-action":
                                        _vm.blockedMobileOfferPopinTms.action,
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.aboutBlockedMobileOfferPopin
                                          .linkLabel
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "modal fade",
                                    attrs: {
                                      id: "modal-more-information",
                                      tabindex: "-1",
                                      role: "dialog",
                                      "aria-labelledby": "modalTitle",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "modal-dialog",
                                        attrs: { role: "document" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "modal-content" },
                                          [
                                            _vm._m(0),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "modal-body" },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    attrs: { id: "modalTitle" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          _vm
                                                            .aboutBlockedMobileOfferPopin
                                                            .title
                                                        ) +
                                                        "\n                                                        "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "row pt-2" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-12" },
                                                      [
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm
                                                                .aboutBlockedMobileOfferPopin
                                                                .line1
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm
                                                                .aboutBlockedMobileOfferPopin
                                                                .line2
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm
                                                                .aboutBlockedMobileOfferPopin
                                                                .line3
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(1),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass:
                        "order-3 order-lg-2 col-12 col-lg-6 px-0 px-1 pb-1 pb-lg-0",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "container mw-100 h-100 border-gray recap-internet-tile px-0",
                        },
                        [
                          _c("div", { staticClass: "row p-1" }, [
                            _c("div", { staticClass: "col-6" }, [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.internetOffer.name)),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 text-end" },
                              [
                                _c("ob1-prix", {
                                  attrs: {
                                    custom: "recap-ob1-price h3 text-dark",
                                    duration: _vm.internetOffer.price.duration,
                                    "initial-price":
                                      _vm.internetOffer.price.initialPrice,
                                    "is-mini": true,
                                    price: _vm.internetOffer.price.price,
                                    "price-details":
                                      _vm.internetOffer.price.priceDetails,
                                    "show-by-month":
                                      _vm.internetOffer.price.showByMonth,
                                    "show-end-of-promotion-price":
                                      _vm.internetOffer.price
                                        .showEndOfPromotionPrice,
                                    "show-from":
                                      _vm.internetOffer.price.showFrom,
                                    "show-promo-duration":
                                      _vm.internetOffer.price.showPromoDuration,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.cartRecapData.mobileDevice
                    ? _c(
                        "section",
                        {
                          staticClass:
                            "order-2 order-lg-3 col-12 px-0 px-1 pb-1 pb-lg-0 pt-lg-1",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "container mw-100 border-gray recap-phone-tile px-0 h-100",
                            },
                            [
                              _c("div", { staticClass: "row p-1" }, [
                                _c("div", { staticClass: "col-7" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-start align-items-center",
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "device-picture-height pe-1",
                                        attrs: {
                                          src: _vm.cartRecapData.mobileDevice
                                            .picturePath,
                                          alt: _vm.cartRecapData.mobileDevice
                                            .pictureAlt,
                                          loading: "lazy",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("p", { staticClass: "mb-0 py-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.cartRecapData.mobileDevice
                                                  .brand
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "mb-0 py-0" }, [
                                          _vm._v(
                                            "\n                                                        " +
                                              _vm._s(
                                                _vm.cartRecapData.mobileDevice
                                                  .name
                                              ) +
                                              "\n                                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ob1-color-chips ob1-color-chips-mini",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "visually-hidden",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Couleur du mobile"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "ob1-color-chip",
                                                      style: {
                                                        backgroundColor:
                                                          _vm.cartRecapData
                                                            .mobileDevice.color
                                                            .code,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ob1-color-chips-mini-tooltip",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.cartRecapData
                                                                .mobileDevice
                                                                .color.colorName
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "ms-1" }, [
                                              _vm._v(
                                                "\n                                                            " +
                                                  _vm._s(
                                                    _vm.cartRecapData
                                                      .mobileDevice.dataCapacity
                                                  ) +
                                                  "\n                                                        "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-5 device-price" },
                                  [
                                    _c("ob1-prix", {
                                      class: "text-end",
                                      attrs: {
                                        price: _vm.devicePrice,
                                        "is-compact": true,
                                        custom: "text-dark",
                                        "is-cents-format": true,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-4 px-0 px-lg-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "container mw-100 h-100 border-gray bg-dark recap-total-tile p-1",
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-5 text-white" }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.cartRecapData.offersTotalPriceLabel)
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-7 text-end" },
                        [
                          _c("ob1-prix", {
                            attrs: {
                              custom: "text-primary",
                              duration: _vm.totalPrice.duration,
                              "initial-price": _vm.totalPrice.initialPrice,
                              "is-compact": _vm.totalPrice.compact,
                              "is-inverse": _vm.totalPrice.inverse,
                              price: _vm.totalPrice.price,
                              "price-details": _vm.totalPrice.priceDetails,
                              "show-by-month": _vm.totalPrice.showByMonth,
                              "show-end-of-promotion-price":
                                _vm.totalPrice.showEndOfPromotionPrice,
                              "show-from": _vm.totalPrice.showFrom,
                              "show-promo-duration":
                                _vm.totalPrice.showPromoDuration,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _vm.mobileOffer.discountLabelWithMobileOfferMention
                        ? _c("div", { staticClass: "col-12" }, [
                            _c("div", { staticClass: "my-1" }, [
                              _c("hr", {
                                staticClass: "separator separator--gray4",
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "my-1 d-flex align-items-center justify-content-center",
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "alert-icon px-1 icon-phone-fund-euro text-primary font-size-28 me-1",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "ob1-alert-title fw-bold text-white",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.formattedMobileDiscountLabel)
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("hr", {
                                staticClass: "separator separator--gray4",
                              }),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.cartRecapData.mobileDevice
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-5 text-white" }, [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.cartRecapData.devicePriceLabel)
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-7 text-end" },
                            [
                              _c("ob1-prix", {
                                class: "text-end",
                                attrs: {
                                  price: _vm.devicePrice,
                                  "is-compact": true,
                                  "is-inverse": true,
                                  "additional-mention-bold":
                                    _vm.cartRecapData.devicePriceOnOrderLabel,
                                  "is-cents-format": true,
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 pt-1 text-center" },
                      [
                        _c("generic-button-cta", {
                          attrs: {
                            "dto-from-object": _vm.selectOfferRecapCta,
                            "css-classes": "btn-primary btn-inverse",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close d-none d-md-block",
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-close d-md-none ob1-link-arrow ob1-link-small back",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [
          _vm._v(
            "\n                                                            Retour\n                                                        "
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [
          _vm._v(
            "\n                                                            Fermer\n                                                        "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }